export const getFileIcon = (fileName: string, isDarkMode = false): string => {
  const ext = fileName.split('.').pop()?.toLowerCase();
  const basePath = '/language_icons/';

  switch (ext) {
    case 'go':
      return `${basePath}go.svg`;
    case 'sln':
    case 'csproj':
      return `${basePath}visual_studio.svg`;
    case 'h':
      return `${basePath}h.svg`;
    case 'c':
      return `${basePath}c.svg`;
    case 'http':
      return `${basePath}http.svg`;
    case 'pdf':
      return `${basePath}pdf.svg`;
    case 'php':
      return `${basePath}php.svg`;
    case 'cpp':
      return `${basePath}cpp.svg`;
    case 'ts':
      return `${basePath}typescript.svg`;
    case 'js':
      return `${basePath}javascript.svg`;
    case 'tsx':
    case 'jsx':
      return `${basePath}react.svg`;
    case 'json':
      return `${basePath}json.svg`;
    case 'html':
      return `${basePath}html.svg`;
    case 'css':
      return `${basePath}css.svg`;
    case 'md':
      return `${basePath}markdown.svg`;
    case 'cs':
      return `${basePath}csharp.svg`;
    case 'java':
      return `${basePath}java.svg`;
    case 'py':
      return `${basePath}python.svg`;
    case 'sql':
    case 'sqllite':
      return `${basePath}database.svg`;
    case 'png':
    case 'jpg':
    case 'jpeg':
    case 'gif':
    case 'svg':
    case 'webp':
    case 'ico':
    case 'bmp':
      return `${basePath}image.svg`;
    case 'xml':
      return `${basePath}xml.svg`;
    case 'gitignore':
      return `${basePath}git.svg`;
    default:
      return `${basePath}document.svg`;
  }
};
